import { Box, Tooltip, Typography } from '@mui/material';
import { type FC } from 'react';

import { type Clusterzuordnung } from '../../../dtos';
import { clusterzuordnungLabels } from '../../../utils';
import { printCluster } from './TerminExpertepoolCard.utils';

const printClusterzuordnungTooltip = (clusterzuordnung: Clusterzuordnung | null): string => {
  if (clusterzuordnung === null) {
    return 'Trainer:in wurde in ContentServ nicht eindeutig einem Cluster (A,B,C) zugeordnet.';
  }

  return clusterzuordnungLabels[clusterzuordnung];
};

type ExpertePoolCellProps = {
  readonly clusterzuordnung: Clusterzuordnung | null;
};

export const ExpertePoolCell: FC<ExpertePoolCellProps> = (props: ExpertePoolCellProps) => (
  <Box maxWidth="1rem" display="flex" height="100%">
    <Tooltip title={printClusterzuordnungTooltip(props.clusterzuordnung)} placement="right">
      <Typography variant="paragraphSm" alignContent="center">
        {printCluster(props.clusterzuordnung)}
      </Typography>
    </Tooltip>
  </Box>
);
